import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Storage } from '@ionic/storage-angular';

export interface RankItem {
  total_score: number;
  first_name: string;
  educational_name: string;
  state: string;
  phone_number: string;
  category: string;
  country: string;
}


@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private apiUrl = 'https://tamil.my/aattam/wp-json/custom/v1/login/';
  private authState = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, private storage: Storage) {}

  loginUser(mykad: string): Observable<any> {
    const body = { mykad: mykad };
    return this.http.post(this.apiUrl, body);
  }

  async saveToken(token: string): Promise<void> {
    try {
      await this.storage.set('authToken', token);
    } catch (error) {}
  }

  async getToken(): Promise<string | null> {
    return await this.storage.get('authToken');
  }

  async saveUserIdentifier(identifier: string): Promise<void> {
    try {
      await this.storage.set('userIdentifier', identifier);
    } catch (error) {}
  }

  async getUserIdentifier(): Promise<string | null> {
    return await this.storage.get('userIdentifier');
  }

  async saveUserDetails(firstName: string, lastName: string, email: string, school: string, state: string, phoneNumber: string, category: string, country: string): Promise<void> {

    try {
      await this.storage.set('firstName', firstName);
      await this.storage.set('lastName', lastName);
      await this.storage.set('email', email);
      await this.storage.set('school', school);
      await this.storage.set('state', state);
      await this.storage.set('phoneNumber', phoneNumber);
      await this.storage.set('category', category);
      await this.storage.set('country', country);
    } catch (error) {}
  }

  async getUserDetails(): Promise<{ firstName: string; lastName: string; email: string; school: string; state: string; phoneNumber: string; category: string; country: string } | null> {
    const firstName = await this.storage.get('firstName');
    const lastName = await this.storage.get('lastName');
    const email = await this.storage.get('email');
    const school = await this.storage.get('school');
    const state = await this.storage.get('state');
    const phoneNumber = await this.storage.get('phoneNumber');
    const category = await this.storage.get('category');
    const country = await this.storage.get('country');
  
    if (firstName && lastName && email && school && state && phoneNumber && category && country) {
      return { firstName, lastName, email, school, state, phoneNumber, category, country };
    }
    return null;
  }
  

  async signOut(): Promise<void> {
    await this.storage.remove('authToken');
    await this.storage.remove('userIdentifier');
    await this.storage.remove('firstName');
    await this.storage.remove('lastName');
    await this.storage.remove('email');
    await this.storage.remove('school');
    await this.storage.remove('state');
    await this.storage.remove('phoneNumber');
    await this.storage.remove('category');
    await this.storage.remove('country');
  }

  setAuthState(isAuthenticated: boolean): void {
    this.authState.next(isAuthenticated);
  }

  getAuthState() {
    return this.authState.asObservable();
  }

  getUserContests(userIdentifier: string): Observable<any[]> {
    const url = 'https://tamil.my/aattam/wp-json/custom/v1/get_user_contest_registration/';
    return this.http.get<any[]>(url, { params: { user_identifier: userIdentifier } });
  }

  getContestRankings(round: number): Observable<RankItem[]> {
    const url = 'https://tamil.my/aattam/wp-json/custom/v1/global_rankings';
    return this.http.get<RankItem[]>(`${url}?round=${round}`);
  }
}
